import { render, staticRenderFns } from "./bottom-nav.vue?vue&type=template&id=10fed816&"
import script from "./bottom-nav.vue?vue&type=script&lang=js&"
export * from "./bottom-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports